import * as Yup from "yup";

export const signupSchema = Yup.object({
  name: Yup.string().min(2).required("ENTER A VALID NAME"),
  email: Yup.string().email().required("ENTER A VALID EMAIL"),
  message: Yup.string().required("ENTER A VALID MESSAGE"),
});
